import ShareCompany from '../models/share-company';
export function shareCompanyDtoToShareCompany(shareCompanyDto) {
  return new ShareCompany(shareCompanyDto.companyId, shareCompanyDto.showCompanyInfoInHeader, shareCompanyDto.authorizationCodeRequired);
}
